module.exports = __webpack_public_path__ + "img/industry_case_fossil.7ff67aa9.png";